export default "__VITE_ASSET__Ctk3JgMB__"